import React from 'react'
import { t } from 'i18n'

const ICONS = {
  danger: 'fa-exclamation-circle',
  success: 'fa-check-circle',
  info: 'fa-info-circle'
}

// Message box with an icon, so the type is not conveyed by colour alone
const Alert = ({ type = 'danger', className = '', onClose, children }) => {
  if (!children) return null

  return (
    <div className={`alert alert-${type} d-flex align-items-baseline ${className}`} role={type === 'danger' ? 'alert' : 'status'}>
      <i className={`fa ${ICONS[type]} me-2`} aria-hidden='true' />
      <div className='flex-grow-1'>{children}</div>
      {onClose && <button type='button' className='btn-close ms-2' aria-label={t('components.notice.close')} onClick={onClose} />}
    </div>
  )
}

export default Alert
